// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FeaturedArticles>.Divider{display:flex;justify-content:center}.FeaturedArticles__textBelowHeading{font-size:1.125rem;text-align:center}.FeaturedArticles .ArticleBox__imageWrapper{min-height:300px}@media(min-width:768px){.FeaturedArticles .ArticleBox--horizontal .ArticleBox__imageLink{flex:0 0 50%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
